var map = {
	"./pages/channel-list-modal/channel-list-modal.module": [
		"./src/app/pages/channel-list-modal/channel-list-modal.module.ts"
	],
	"./pages/channels/channels.module": [
		"./src/app/pages/channels/channels.module.ts",
		"common",
		"pages-channels-channels-module"
	],
	"./pages/control-antenna/control.antenna.module": [
		"./src/app/pages/control-antenna/control.antenna.module.ts",
		"common",
		"pages-control-antenna-control-antenna-module"
	],
	"./pages/control/control.module": [
		"./src/app/pages/control/control.module.ts",
		"common",
		"pages-control-control-module"
	],
	"./pages/geolocation-test/geolocation-test.module": [
		"./src/app/pages/geolocation-test/geolocation-test.module.ts",
		"common",
		"pages-geolocation-test-geolocation-test-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"common",
		"pages-home-home-module"
	],
	"./pages/landing/landing.module": [
		"./src/app/pages/landing/landing.module.ts",
		"common",
		"pages-landing-landing-module"
	],
	"./pages/logging/logging.module": [
		"./src/app/pages/logging/logging.module.ts",
		"pages-logging-logging-module"
	],
	"./pages/scan/scan.module": [
		"./src/app/pages/scan/scan.module.ts",
		"common",
		"pages-scan-scan-module"
	],
	"./pages/setup/setup.module": [
		"./src/app/pages/setup/setup.module.ts",
		"common",
		"pages-setup-setup-module"
	],
	"./pages/watch-tv/watch-tv.module": [
		"./src/app/pages/watch-tv/watch-tv.module.ts",
		"common",
		"pages-watch-tv-watch-tv-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;